import { useQuery } from "@tanstack/react-query";
import { useCompanyIdFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
import apiClient from "@/modules/request.module.v2";

const fetchShareholdersByIds = (companyId, ids, params) => {
  return apiClient.post(
    "/shares/investments/array",
    { ids },
    {
      params,
      headers: { "x-company-id": companyId },
    },
  );
};

const useShareholdersByIds = (ids = []) => {
  const companyId = useCompanyIdFromUrl();

  const query = useQuery({
    queryKey: ["shareholdersByIds", { companyId, ids }],
    queryFn: () => {
      return fetchShareholdersByIds(companyId, ids);
    },
  });

  return query;
};

export { useShareholdersByIds, fetchShareholdersByIds };
